import { idSchema } from "@reactive-resume/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { secretsSchema } from "../secrets";

export const usernameSchema = z
  .string()
  .min(3)
  .max(255)
  .regex(/^[\d._a-z-]+$/, {
    message:
      "Usernames can only contain lowercase letters, numbers, periods, hyphens, and underscores.",
  });

// Organization schema
const organizationDetailsSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string().optional().nullable(),
  })
  .optional()
  .nullable();

const departmentSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
  })
  .optional()
  .nullable();

const courseSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
  })
  .optional()
  .nullable();

const programSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
  })
  .optional()
  .nullable();

const batchSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
  })
  .optional()
  .nullable();

const sectionSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
  })
  .optional()
  .nullable();

const organizationSchema = z
  .object({
    id: z.string().uuid().optional().nullable(),
    department: departmentSchema,
    course: courseSchema,
    program: programSchema,
    batch: batchSchema,
    section: sectionSchema,
  })
  .optional()
  .nullable();

export const userSchema = z.object({
  id: idSchema,
  studentId: z.string().uuid(), // Matches the UUID type for studentId
  firstName: z.string().min(1).max(255), // Added firstName field
  lastName: z.string().min(1).max(255), // Added lastName field
  rollNo: z.string().min(1).max(50), // Added rollNo field with a maximum length
  name: z.string().min(1).max(255),
  picture: z.literal("").or(z.null()).or(z.string().url()),
  username: usernameSchema,
  email: z.string().email(),
  phoneNumber: z.string().min(10).max(15),
  locale: z.string().default("en-US"),
  emailVerified: z.boolean().default(false),
  twoFactorEnabled: z.boolean().default(false),
  provider: z.enum(["email", "github", "google"]).default("email"),
  createdAt: z.date().or(z.dateString()),
  updatedAt: z.date().or(z.dateString()),
  organization: organizationSchema,
});

export class UserDto extends createZodDto(userSchema) {}

export const userWithSecretsSchema = userSchema.merge(z.object({ secrets: secretsSchema }));

export class UserWithSecrets extends createZodDto(userWithSecretsSchema) {}
